import { useState, useEffect } from 'react';
import { useDebouncedSearch } from '~/Hooks';
import { IListToolbarProps } from '.';
import { RearrangeStatus } from '../models/RearrangeStatus.enum';
import { useListToolbarStyles } from './ListToolbar.styles';

export const useListToolbar = ({
  items,
  onSelectAll,
  onSearch,
  onRearrange,
  bulkActions,
  isSelectionActive,
  resetSearch,
  sortOptions,
}: IListToolbarProps) => {
  const [isRearranging, setIsRearranging] = useState(false);

  const { inputText: searchText, setInputText: updateSearchText } = useDebouncedSearch(onSearch);

  useEffect(() => {
    if (resetSearch) {
      updateSearchText('');
    }
  }, [resetSearch]);

  const startRearranging = () => {
    setIsRearranging(true);
    onRearrange?.(RearrangeStatus.STARTED);
  };
  const stopRearranging = () => {
    setIsRearranging(false);
    onRearrange?.(RearrangeStatus.CANCELED);
  };
  const saveRearranging = () => {
    setIsRearranging(false);
    onRearrange?.(RearrangeStatus.DONE);
  };

  const numberOfItems = items.length;
  const numberOfSelectedItems = items.filter((item) => item.checked).length;

  const isAllSelected = numberOfItems === numberOfSelectedItems && numberOfItems > 0;
  const isIndeterminate = !isAllSelected && !!numberOfSelectedItems;

  const show = {
    select: !!onSelectAll && !isRearranging,
    search: !!onSearch && !isRearranging,
    rearrange: !!onRearrange && !isRearranging && !isSelectionActive && !searchText,
    rearranging: !!onRearrange && isRearranging && !isSelectionActive && !searchText,
    bulkActions: !!bulkActions?.length && !isRearranging && !!isSelectionActive && !searchText,
    sort: !!sortOptions,
  };

  const { classes } = useListToolbarStyles();

  return {
    searchText,
    updateSearchText,
    startRearranging,
    stopRearranging,
    saveRearranging,
    numberOfSelectedItems,
    isAllSelected,
    isIndeterminate,
    classes,
    show,
  };
};
